export const FIELDS_SPECIAL = [
    "DateTime",
    "Date",
    "Time",
    "Site",
    "Parcelle_name",
    "Cepage",
  ];